import { ArrowRight as UiArrowRight, CreditCard as UiCreditCard } from '../components/icons';
// frontend/src/pages/BankAccountsPage.jsx
import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import BankAccounts from '../components/BankAccounts';

export default function BankAccountsPage() {
  const navigate = useNavigate();

  return (
    <>
      <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 px-4 py-8 font-vazir">
        <div className="max-w-4xl mx-auto">

          {/* دکمه برگشت */}
          <motion.button
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            whileHover={{ x: -5 }}
            onClick={() => navigate('/profile_page')}
            className="flex items-center text-indigo-600 font-medium mb-8 group"
          >
            <UiArrowRight className="w-5 h-5 ml-1 transition-transform group-hover:-translate-x-1" />
            برگشت
          </motion.button>

          {/* عنوان */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="text-center mb-10"
          >
            <div className="flex justify-center items-center gap-3 mb-3">
              <div className="w-12 h-12 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-2xl flex items-center justify-center shadow-lg">
                <UiCreditCard className="w-7 h-7 text-white" />
              </div>
            </div>
            <h1 data-page-title="true" className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 bg-clip-text text-transparent">
              مدیریت حساب‌های بانکی
            </h1>
            <p className="text-gray-600 mt-3 text-lg">
              حساب‌های خود را اضافه، ویرایش یا حذف کنید
            </p>
          </motion.div>

          {/* کامپوننت اصلی */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="bg-white rounded-3xl shadow-xl border border-gray-200 overflow-hidden"
          >
            <BankAccounts />
          </motion.div>

          {/* توضیحات پایین */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="mt-8 text-center text-sm text-gray-500 bg-white/70 backdrop-blur-sm rounded-2xl p-4 border border-gray-200"
          >
            <p>برای برداشت وجه، حداقل یک حساب بانکی تأیید شده نیاز است.</p>
          </motion.div>
        </div>
      </div>
    </>
  );
}